export const VIEW_NAME_MAX_LENGTH = 40;
export const MAX_USER_CREATED_VIEWS = 5;
export const VIEW_NAME_PATTERN = /^[a-zA-Z0-9 ]*$/;
export const VIEW_NAME_SPECIAL_CHARS_ERROR = 'Special characters not allowed';
export const VIEW_NAME_DUPLICATE_ERROR = 'This name already exists';

export const SAVE_CURRENT_VIEW_TOOLTIP = 'Save your current configuration for quick access';
export const SAVE_VIEW_LIMIT_TOOLTIP = 'Only 5 Views allowed.';
export const UPDATED_VIEW_MODIFIED_TOOLTIP =
    'The scope of this View has changed.\nUpdate the View to save the changed scope.';

export const SAVE_VIEW_TOOLTIP_PROPS = {
    color: '#000000D9',
    placement: 'top' as const,
    getPopupContainer: () => document.body,
    overlayStyle: { zIndex: 1100 },
    overlayInnerStyle: {
        borderRadius: 8,
        fontSize: 14,
        fontWeight: 400,
        backgroundColor: '#000000D9',
        whiteSpace: 'pre-line' as const,
    },
};
